<template>
  <div style="direction: ltr">
    <div class="main-content">
      <div style="text-align: right; margin-bottom: 20px">
        <el-button
          type="default"
          plain
          @click="page = 2"
          :class="page == 2 ? 'active-btn-page' : ''"
          >کنترل چاه</el-button
        >
        <el-button
          type="default"
          plain
          @click="page = 1"
          :class="page == 1 ? 'active-btn-page' : ''"
          >وضعیت کلی</el-button
        >
      </div>
      <div v-if="page == 1">
        <!-- عنوان -->
        <el-card
          shadow="never"
          style="margin-bottom: 20px"
          v-loading="deviceStore.isLoading"
        >
          <div style="font-weight: bold; font-size: 18px">
            خلاصه وضعیت {{ deviceStore.activeDevice?.name }}
          </div>
        </el-card>

        <el-row :gutter="10" class="flex-wrap custom-height">
          <!-- چارت بالا سمت راست -->
          <el-col :xs="24" :sm="24" :md="12" :lg="10">
            <el-card v-loading="loading">
              <div
                v-if="!xWeekData || xWeekData.length == 0"
                class="card highlight"
                :style="{
                  height: isMobile ? '230px' : '350px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  fontSize: isMobile ? '14px' : '18px',
                  color: '#999',
                  fontWeight: 'bold',
                }"
              >
                دیتایی برای رسم نمودار مصرف آب و کارکرد هفتگی وجود ندارد
              </div>
              <BaseChart
                v-else
                class="card"
                type="bar"
                mode="weekly"
                :height="chartHeight"
                :isMobile="isMobile"
                title=" حجم آب مصرفی و کارکرد در هفته   "
                :data="[
                  { name: 'مصرف آب', data: yWeekData, unit: 'مترمکعب' },
                  {
                    name: 'ساعت کارکرد',
                    data: operatingHours,
                    unit: 'ساعت',
                  },
                ]"
                :categories="xWeekData"
                name="میزان مصرف "
              />
            </el-card>
          </el-col>

          <!-- چارت بالا سمت چپ -->
          <el-col :xs="24" :sm="24" :md="12" :lg="14">
            <el-card v-loading="xTodayData == null">
              <div
                v-if="!xTodayData || xTodayData.length === 0"
                class="card highlight"
                :style="{
                  height: isMobile ? '230px' : '350px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  fontSize: isMobile ? '14px' : '18px',
                  color: '#999',
                  fontWeight: 'bold',
                }"
              >
                دیتایی برای رسم نمودار مصرف آب روزانه وجود ندارد
              </div>
              <BaseChart
                v-else
                class="card highlight"
                type="line"
                :height="chartHeight"
                :isMobile="isMobile"
                title="حجم آب عبوری در شبانه‌ روز"
                :data="[
                  { name: ' میزان مصرف آب', data: yTodayData, unit: 'مترمکعب/ساعت' },
                ]"
                mode="daily"
                :categories="xTodayData"
                name="حجم عبور"
              />
            </el-card>
          </el-col>

          <!-- چارت دایره‌ای پایین -->
          <el-col
            :xs="24"
            :sm="24"
            :md="12"
            :lg="10"
            class="hide-export-excel-btn custom-card-height pie-chart"
          >
            <el-card
              style="flex: 1; overflow: auto; height: 100%"
              v-loading="pieData == null"
            >
              <BaseChart
                class="card"
                type="pie"
                :height="chartHeight"
                :isMobile="isMobile"
                title="عملکرد پمپ در هفته"
                :data="pieData"
                name="میزان ساعت  "
              />
            </el-card>
          </el-col>

          <!-- جدول پایین -->
          <el-col
            :xs="24"
            :sm="24"
            :md="12"
            :lg="14"
            class="custom-card-height"
          >
            <el-card
              style="flex: 2; overflow: auto"
              v-loading="tableData == null || loading"
            >
              <div>جدول عملکرد</div>
              <table-report :data="tableData" />
            </el-card>
          </el-col>
          <el-col :md="24" class="custom-card-height"
            ><div style="height: 50px"></div
          ></el-col>
        </el-row>
      </div>
      <div v-else>
        <!-- عنوان -->
        <el-card shadow="never" style="margin-bottom: 20px">
          <div style="font-weight: bold; font-size: 18px">
            مدیریت {{ deviceStore.activeDevice?.name }}
          </div>
        </el-card>
        <pump-schedule ref="pumpScheduleRef" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, watch ,computed,onUnmounted} from "vue";
import jmoment from "moment-jalaali";
import BaseChart from "@/components/BaseChart.vue";
import TableReport from "@/components/TableReport.vue";
import PumpSchedule from "@/components/PumpSchedule.vue";
import { useDeviceStore } from "@/stores/device";
import { showToast } from "@/utils/toastHelper";
import {
  fetchReportCommandCount,
  fetchReportFlowmeter,
  fetchStatusWell,
} from "@/services/auth";
import socket from "@/services/socket";

const deviceStore = useDeviceStore();
const pumpScheduleRef = ref(null);

const isMobile = ref(false);
const chartHeight = ref("370px");
const page = ref(1);
const pieData = ref(null);
const tableData = ref(null);
const xTodayData = ref(null);
const yTodayData = ref(null);
const xWeekData = ref([]);
const yWeekData = ref([]);
const loading = ref(true);

const operatingHours = ref([0, 0, 0, 0, 0, 0, 0]);
const checkMobile = () => {
  isMobile.value = window.innerWidth <= 768;
  chartHeight.value = isMobile.value ? "250px" : "370px";
};



onMounted(() => {
  const token = localStorage.getItem("token");
  if (token) {
    socket.connect(token);
  }
});
onUnmounted(() => {
      socket.off("motor/status");
      socket.leaveRoom(deviceStore.activeDevice?.pin);
      console.log(`❌ Left well`);
    });
onMounted(() => {
  window.addEventListener("resize", checkMobile);
  checkMobile();
  if (pieData.value == null && deviceStore.activeDevice) {
    callNextApi();
  }
});
/*
onBeforeUnmount(() => {
  socket.disconnect();
  window.removeEventListener("resize", checkMobile);
});*/
watch(
  () => deviceStore.activeDevice,
  (newVal, oldVal) => {
    if (newVal && newVal !== oldVal) {
      callNextApi();
      if (!socket.connected) return; // اگر هنوز کانکت نیستیم کاری نکن

      if (oldVal?.pin) socket.leaveRoom(oldVal.pin);

      if (newVal?.pin) {
        socket.joinRoom(newVal.pin);
        getStatusWell();
      }
    }
  },
  { immediate: true }
);
async function getStatusWell() {
  const response = await fetchStatusWell(deviceStore.activeDevice.id);
  deviceStore.updateActiveDeviceStatusWell(response.data[0].status);
}
const formatWeek = (dates) => {
  if (!Array.isArray(dates)) return [];
  return dates.map((d) => {
    const jm = jmoment(d, ["jYYYY/jMM/jDD HH:mm", "jYYYY/jMM/jDD"], true);
    if (!jm.isValid()) return d;
    let dayName = jm.format("dddd");
    if (dayName === "آدینه") dayName = "جمعه";
    return dayName;
  });
};
function initialTable(date, value) {
  if (!Array.isArray(date) || !Array.isArray(value)) return [];

  // گرفتن نام روزها از روی تاریخ‌ها
  const dayNames = formatWeek(date);

  // ساختن آبجکت‌ها
  return date.map((date, i) => {
    const onHours = value[i] || 0;
    return {
      date, // تاریخ شمسی
      dayName: dayNames[i], // نام روز
      onHours, // ساعات روشن بودن
      offHours: 24 - onHours, // ساعات خاموش بودن
      capacity: 0, // اگه لازم باشه بعداً پر بشه
    };
  });
}
const addPoint = (x, y) => {
  // اگر آرایه‌ها null بودن، آرایه خالی بساز
  if (!xTodayData.value) xTodayData.value = [];
  if (!yTodayData.value) yTodayData.value = [];

  const lastIndex = xTodayData.value.length - 1;

  if (lastIndex >= 0 && xTodayData.value[lastIndex] === x) {
    // اگر x تکراری بود → میانگین بگیر
    const oldY = yTodayData.value[lastIndex];
    if (oldY == null) {
      yTodayData.value[lastIndex] = y; // اگر قبلی null بود فقط جدید رو بذار
    } else {
      yTodayData.value[lastIndex] = (oldY + y) / 2;
    }
  } else {
    // اگر جدید بود → push کن
    xTodayData.value.push(x);
    yTodayData.value.push(y);
  }
};

setTimeout(() => {
  socket.on("flowmeter/today", (data) => {
  //  console.log(data)
   addPoint(data.xAxis,data.yAxis)
   
   
  });
  socket.on("motor/status", (data) => {
    if (data.status == 2) return;

    deviceStore.updateActiveDeviceStatusWell(data.status);
    if (pumpScheduleRef.value) {
      // تغییر متغیر فرزند
      pumpScheduleRef.value.pumpStatus = data.status == 1 ? true:false;
     
    }
    showToast(
      (data.status == 1 ? " روشن کردن پمپ " : " خاموش کردن پمپ ") +
        " با موفقیت انجام شد ",
      "success"
    );
  });
}, 5000); // ۲ ثانیه بعد از اجرا

async function callNextApi() {
  loading.value=true
  pieData.value=null
  tableData.value=null
  xTodayData.value=null
  try {
    const response = await fetchReportCommandCount({
      ids: [deviceStore.activeDevice.device_id],
      reportType: 0,
      type: 1,
    });

    const wellData = response.data.list[0].series[0]; // آبجکت داخلی
    tableData.value = initialTable(wellData.xAxis, wellData.yAxis);
    xWeekData.value = wellData.xAxis;
    operatingHours.value = wellData.yAxis;
    pieData.value = [
      { name: "خاموش بودن", value: wellData.totalOff },
      { name: "روشن بودن", value: wellData.totalOn },
    ];

    const chartData = await fetchReportFlowmeter({
      ids: [deviceStore.activeDevice.device_id],
      reportType: 0,
      type: 0,
    });

    if (chartData.data.list && chartData.data.list.length > 0) {
      xTodayData.value = chartData.data.list[0].xAxis;
      yTodayData.value = chartData.data.list[0].yAxis;
    } else {
      xTodayData.value = [];
      yTodayData.value = [];
    }

    const weekData = await fetchReportFlowmeter({
      ids: [deviceStore.activeDevice.device_id],
      reportType: 0,
      type: 1,
    });
    loading.value=false;
    if (weekData.data.list && weekData.data.list.length > 0) {
      xWeekData.value = weekData.data.list[0].series[0].xAxis;
      yWeekData.value = weekData.data.list[0].series[0].yAxis;
      tableData.value.forEach((item) => {
        const index = xWeekData.value.indexOf(item.date);
        if (index !== -1) {
          item.capacity = yWeekData.value[index];
          operatingHours.value[index] = item.onHours;
        }
      });
    } else {
      xWeekData.value = [];
      yWeekData.value = [];
    }
  } catch (error) {
     if (error.response && error.response.status === 401) {
     
    deviceStore.reset();
    window.location.href = "/login";
    } else {
      console.error("خطای دیگر:", error);
    }
  

  }
}
</script>

<style scoped>
.mobile-header {
  background-color: #205685;
  color: white;
  display: flex;
  align-items: center;
  height: 60px;
  direction: rtl;
}
.main-content {
  padding: 1rem;
}
.main-container {
  direction: ltr;
}
.custom-height {
  display: flex !important;
  align-items: stretch !important;
  height: 380px;
}
.custom-card-height {
  display: flex !important;
  flex-direction: column !important;
}
.el-col {
  margin-bottom: 10px;
}
.active-btn-page {
  background: #5f8cc5;
  color: white;
}

</style>
